
export default function TestimonialsSection() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const testimonials = [
    {
      name: 'Carmen Rodríguez',
      role: 'Hija de Paciente',
      service: 'Cuidado Residencial',
      avatar: 'https://public.readdy.ai/ai/img_res/8f1ac584946b23be4851caf217d7f917.jpg',
      text: 'Las enfermeras de URI son verdaderamente excepcionales. El nivel de profesionalismo con el que atendieron a mi madre fue impresionante: desde el manejo de su medicación hasta los cuidados posoperatorios. Nunca imaginé encontrar un equipo tan capacitado y a la vez tan humano. Mi familia está profundamente agradecida.',
      stars: 5,
    },
    {
      name: 'Alejandro Martínez',
      role: 'Hijo de Paciente',
      service: 'Asistencia Hospitalaria',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20latino%20man%2045s%20confident%20warm%20smile%20simple%20neutral%20background%20headshot%20photography&width=200&height=200&seq=test_lat002&orientation=squarish',
      text: 'El equipo de asistencia hospitalaria de URI marcó una diferencia enorme durante la recuperación de mi padre. Su coordinación con los médicos fue impecable y siempre estuvieron atentos a cada detalle. Saber que había profesionales especializados cuidándolo nos dio una tranquilidad que no tiene precio.',
      stars: 5,
    },
    {
      name: 'Luisa Fernanda Pérez',
      role: 'Paciente',
      service: 'Cuidado Especializado',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20latina%20woman%2065s%20gentle%20smile%20kind%20expression%20simple%20warm%20background%20headshot%20photography&width=200&height=200&seq=test_lat003&orientation=squarish',
      text: 'Recibí cuidados especializados en casa tras mi cirugía y la atención fue de primer nivel. Las enfermeras de URI demostraron un dominio técnico extraordinario en el manejo de mis equipos médicos. Me sentí segura y bien cuidada en todo momento. Los recomiendo ampliamente.',
      stars: 5,
    },
    {
      name: 'Roberto Guzmán',
      role: 'Esposo de Paciente',
      service: 'Cuidado Domiciliario 24/7',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20latino%20man%2055s%20serious%20trustworthy%20expression%20simple%20neutral%20background%20headshot%20photography&width=200&height=200&seq=test_lat004&orientation=squarish',
      text: 'Mi esposa requería cuidados continuos y el equipo de URI respondió con una dedicación admirable. La especialización de sus enfermeras en el manejo de pacientes crónicos es notable. Siempre puntuales, siempre preparados. Es un servicio que realmente cumple lo que promete.',
      stars: 5,
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-uri-teal/10 text-uri-teal text-sm font-semibold rounded-full mb-4">
            Testimonios
          </span>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Lo Que Dicen Nuestras Familias
          </h3>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Experiencias reales de familias venezolanas que confían en el cuidado profesional y especializado de URI
          </p>
        </div>

        {/* Featured Testimonial */}
        <div className="bg-white rounded-3xl shadow-xl p-10 mb-8 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-uri-teal/5 rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="relative">
            <div className="flex items-center gap-2 mb-6">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
              ))}
              <span className="ml-2 text-sm font-bold text-gray-700 bg-gray-100 px-3 py-1 rounded-full">5.0</span>
            </div>
            <i className="ri-double-quotes-l text-6xl text-uri-teal opacity-15 mb-2 block"></i>
            <p className="text-xl text-gray-800 leading-relaxed mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
              "{testimonials[0].text}"
            </p>
            <div className="flex items-center gap-4">
              <img
                src={testimonials[0].avatar}
                alt={testimonials[0].name}
                className="w-16 h-16 rounded-full object-cover object-top border-2 border-uri-teal/20"
              />
              <div>
                <h4 className="font-bold text-gray-900 text-lg">{testimonials[0].name}</h4>
                <p className="text-sm text-gray-500">{testimonials[0].role}</p>
                <span className="inline-block mt-1 text-xs font-semibold text-uri-teal bg-uri-teal/10 px-3 py-0.5 rounded-full">
                  {testimonials[0].service}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Grid Testimonials */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {testimonials.slice(1).map((t, idx) => (
            <div key={idx} className="bg-white rounded-2xl shadow-md p-7 flex flex-col justify-between hover:shadow-lg transition-shadow">
              <div>
                <div className="flex items-center gap-1 mb-4">
                  {[...Array(t.stars)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-gray-700 leading-relaxed mb-6">
                  "{t.text}"
                </p>
              </div>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-11 h-11 rounded-full object-cover object-top border border-gray-200"
                />
                <div>
                  <h5 className="font-semibold text-gray-900 text-sm">{t.name}</h5>
                  <p className="text-xs text-gray-500">{t.role}</p>
                  <span className="inline-block mt-0.5 text-xs font-medium text-uri-teal">{t.service}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats bar */}
        <div className="bg-white rounded-2xl shadow-md px-8 py-6 flex flex-wrap justify-around gap-6 mb-12">
          {[
            { icon: 'ri-star-fill', value: '4.9/5', label: 'Calificación Promedio', color: 'text-yellow-500' },
            { icon: 'ri-user-heart-line', value: '5,000+', label: 'Familias Atendidas', color: 'text-uri-teal' },
            { icon: 'ri-nurse-line', value: '200+', label: 'Enfermeras Certificadas', color: 'text-uri-green' },
            { icon: 'ri-thumb-up-line', value: '98%', label: 'Satisfacción del Paciente', color: 'text-uri-blue' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className={`text-3xl ${stat.color} mb-1`}>
                <i className={stat.icon}></i>
              </div>
              <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
              <p className="text-xs text-gray-500 mt-0.5">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-gray-600 mb-4">¿Listo para experimentar un cuidado excepcional?</p>
          <button
            onClick={() => scrollToSection('intake')}
            className="px-8 py-3 bg-uri-teal text-white font-semibold rounded-lg hover:bg-uri-teal-dark transition-colors cursor-pointer whitespace-nowrap"
          >
            Comience Hoy
          </button>
        </div>
      </div>
    </section>
  );
}
